module.exports = "<yeti-modal-dialog [modalHeader]=\"headerText\" [modalComponent]=\"this\" \r\n        *ngIf=\"(currentUserService.changeRetailerModalViewStatus$ | async)\" [adjustCss]=\"false\">\r\n    <div class=\"yeti-modal-body\">{{message}}</div>\r\n    <div class=\"yeti-modal-footer\">\r\n        <button type=\"button\" class=\"yeti-button-no\" (click)=\"close()\">{{cancelText}}</button>\r\n        <button type=\"button\" class=\"yeti-button-yes\" (click)=\"close(true)\">{{okayText}}</button>\r\n    </div>\r\n</yeti-modal-dialog>"


//////////////////
// WEBPACK FOOTER
// ./src/app/change-retailer-confirmation/change-retailer-confirmation.component.html
// module id = 649
// module chunks = 0